export class Country{
    code = '';
    dial_code = '';
    name = '';
    searchQuery = '';
  }
export class Tokens {
    AccessToken = '';
    ExpiresIn? = 0;
    TokenType? = '';
    RefreshToken? = '';
    IdToken = '';
}

export class TokensParams {
    [key: string]: string;
    code = '';
    state = '';
    provider = '';
}